export default __webpack_public_path__ + "static/media/vision.8336fe84.png";